module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "custom-home-contact",
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "custom-home-contact__container"
  }, [_c('div', {
    staticClass: "custom-home-contact__col"
  }, _vm._l((_vm.props.acf.information.location_list), function(MapList, j) {
    return _c('div', {
      staticClass: "custom-home-contact__map-overlay"
    }, [(MapList.iframe_url) ? _c('iframe', {
      staticClass: "custom-home-contact__map",
      staticStyle: {
        "border": "0"
      },
      attrs: {
        "title": "Map - " + MapList.name,
        "src": MapList.iframe_url,
        "frameborder": "0",
        "allowfullscreen": "allowfullscreen"
      }
    }) : _vm._e(), _c('div', {
      staticClass: "name"
    }, [_vm._v("Location " + _vm._s(j + 1) + " :                      ")])])
  }), 0), _c('div', {
    staticClass: "custom-home-contact__col"
  }, [_c('div', {
    staticClass: "custom-home-contact__title"
  }, [_vm._v("Our Locations")]), _c('div', {
    staticClass: "custom-home-contact__info-container"
  }, [_c('div', {
    staticClass: "custom-home-contact__email"
  }, [_c('Icon', {
    staticClass: "custom-home-contact__icon",
    attrs: {
      "name": "mail"
    }
  }), _c('span', [_c('a', {
    attrs: {
      "href": _vm.props.acf.email_href,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v(_vm._s(_vm.props.acf.information.email))])])], 1), _c('div', {
    staticClass: "custom-home-contact__phone"
  }, [_c('Icon', {
    staticClass: "custom-home-contact__icon",
    attrs: {
      "name": "phone"
    }
  }), _c('span', [_c('a', {
    attrs: {
      "href": _vm.props.acf.phone_href,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v(_vm._s(_vm.props.acf.information.phone))])])], 1), _c('div', {
    staticClass: "custom-home-contact__fax"
  }, [_c('Icon', {
    staticClass: "custom-home-contact__icon",
    attrs: {
      "name": "fax"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.props.acf.information.fax) + "  ")])], 1), _vm._l((_vm.props.acf.information.location_list), function(LocList, i) {
    return (_vm.props.acf.information.location_list) ? _c('div', {
      staticClass: "loc_inner"
    }, [_c('h3', [_vm._v("Location " + _vm._s(i + 1) + " :")]), _c('div', {
      staticClass: "custom-home-contact__location"
    }, [_c('Icon', {
      staticClass: "custom-home-contact__icon",
      attrs: {
        "name": "location"
      }
    }), _c('span', [(LocList.adress_url) ? _c('a', {
      attrs: {
        "href": LocList.adress_url,
        "target": "_blank"
      }
    }, [(LocList.address) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(LocList.address)
      }
    }) : _vm._e()]) : _vm._e()])], 1)]) : _vm._e()
  })], 2)])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bfd661e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-home-contact/custom-home-contact.pug
// module id = 668
// module chunks = 1